import { StringFilter } from './string-filter';
import { EntityType } from './entity-type';
import { RiskFormulaStatus } from './risk-formula-status';

export class RiskFormulaFilter {
  name?: StringFilter;
  entityType?: EntityType;
  targetType?: EntityType;
  status?: RiskFormulaStatus;
}
